import { Text, VStack } from "@chakra-ui/react";
import { CardItem } from "../CardItem";
import { ICard } from "../../../../api/cards/types.ts";

interface Props {
  title: string;
  cards: ICard[];
  isLastLinkedCard: boolean;
  isProductStatusChanging: boolean;
  setMainProduct: (cardId: string) => Promise<void>;
}

export function FilledCardListGroup({ title, cards, isLastLinkedCard, isProductStatusChanging, setMainProduct }: Props) {
  if (cards.length === 0) {
    return null;
  }

  return (
    <VStack spacing={0} alignItems="flex-start" mb="6px">
      <Text fontSize="sm" mb="4px">{title}</Text>

      {cards.map(card => (
        <CardItem
          key={card.productId}
          card={card}
          isLastLinkedCard={isLastLinkedCard}
          setMainProduct={setMainProduct}
          isProductStatusChanging={isProductStatusChanging}
        />
      ))}
    </VStack>
  );
}
